<template>
  <div>
    <b-row>
      <b-col
        lg="3"
        sm="6"
        v-for="item in first"
        :key="item.subtitle"
        class="cursor-pointer"
        @click="handleClick(item)"
      >
        <statistic-card-horizontal
          :icon="item.icon"
          :statistic="item.title"
          :statistic-title="item.subtitle"
          :color="item.color"
        />
      </b-col>
      <!-- <b-col lg="3" sm="6">
        <statistic-card-horizontal
          icon="UsersIcon"
          color="success"
          statistic="1.2gb"
          statistic-title="Total Franchise"
        />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
          icon="UsersIcon"
          color="danger"
          statistic="0.1%"
          statistic-title="Total Employee"
        />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
          icon="ServerIcon"
          color="warning"
          statistic="13"
          statistic-title="Total Branch"
        />
      </b-col> -->
    </b-row>

    <b-row>
      <b-col lg="3" sm="6" v-for="item in second" :key="item.subtitle">
        <statistic-card-with-area-chart
          :icon="item.icon"
          :statistic="kFormatter(item.title)"
          :statistic-title="item.subtitle"
          :color="item.color"
          :chart-data="item.data"
        />
      </b-col>
      <!-- <b-col lg="3" sm="6">
        <statistic-card-with-area-chart
          icon="CreditCardIcon"
          color="success"
          :statistic="kFormatter(revenueGenerated.analyticsData.revenue)"
          statistic-title="This Week Business"
          :chart-data="revenueGenerated.series"
        />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-with-area-chart
          icon="ShoppingCartIcon"
          color="danger"
          :statistic="kFormatter(quarterlySales.analyticsData.sales)"
          statistic-title="This Month Business"
          :chart-data="quarterlySales.series"
        />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-with-area-chart
          icon="PackageIcon"
          color="warning"
          :statistic="kFormatter(ordersRecevied.analyticsData.orders)"
          statistic-title="This Year Business"
          :chart-data="ordersRecevied.series"
        />
      </b-col> -->
    </b-row>
    <b-row>
      <b-col
        lg="3"
        sm="6"
        v-for="item in third"
        :key="item.subtitle"
        class="cursor-pointer"
        @click="handleClick(item)"
      >
        <statistic-card-horizontal
          :icon="item.icon"
          :statistic="item.title"
          :statistic-title="item.subtitle"
          :color="item.color"
        />
      </b-col>
      <b-col lg="3" sm="6" class="cursor-pointer" @click="handleClickvisit()">
        <statistic-card-horizontal
          icon="UserIcon"
          :statistic="visitCount"
          statistic-title="Site Visit Request"
          color="warning"
        />
      </b-col>
    </b-row>

    <!-- <b-row class="match-height">
      <b-col lg="2" cols="6">
        <card-statistic-order-chart />
      </b-col>
      <b-col lg="2" cols="6">
        <card-statistic-profit-chart />
      </b-col>
      <b-col lg="8" cols="12">
        <card-statistics-group />
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col xl="2" md="4" sm="6">
        <statistic-card-vertical
          icon="EyeIcon"
          statistic="36.9k"
          statistic-title="Views"
          color="info"
        />
      </b-col>
      <b-col xl="2" md="4" sm="6">
        <statistic-card-vertical
          color="warning"
          icon="MessageSquareIcon"
          statistic="12k"
          statistic-title="Comments"
        />
      </b-col>
      <b-col xl="2" md="4" sm="6">
        <statistic-card-vertical
          color="danger"
          icon="ShoppingBagIcon"
          statistic="97.8k"
          statistic-title="Orders"
        />
      </b-col>
      <b-col xl="2" md="4" sm="6">
        <statistic-card-vertical
          color="primary"
          icon="HeartIcon"
          statistic="26.8"
          statistic-title="Favorited"
        />
      </b-col>
      <b-col xl="2" md="4" sm="6">
        <statistic-card-vertical
          color="success"
          icon="AwardIcon"
          statistic="689"
          statistic-title="Reviews"
        />
      </b-col>
      <b-col xl="2" md="4" sm="6">
        <statistic-card-vertical
          hide-chart
          color="danger"
          icon="TruckIcon"
          statistic="2.1k"
          statistic-title="Returns"
        />
      </b-col>
    </b-row> -->

    <!-- Stats Card Horizontal -->

    <!-- Stats Card w/ Area Chart -->

    <!-- Stats Card w/ line chart -->
    <!-- <b-row>
      <b-col md="4" sm="6">
        <statistic-card-with-line-chart
          icon="MonitorIcon"
          statistic="78.9k"
          statistic-title="Site Traffic"
          :chart-data="siteTraffic.series"
        />
      </b-col>
      <b-col md="4" sm="6">
        <statistic-card-with-line-chart
          icon="UserCheckIcon"
          color="success"
          statistic="659.8k"
          statistic-title="Active Users"
          :chart-data="activeUsers.series"
        />
      </b-col>
      <b-col md="4" sm="6">
        <statistic-card-with-line-chart
          icon="MailIcon"
          color="warning"
          statistic="28.7k"
          statistic-title="Newsletter"
          :chart-data="newsletter.series"
        />
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import axios from '@/components/axios';

import { BRow, BCol } from "bootstrap-vue";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import StatisticCardWithAreaChart from "@core/components/statistics-cards/StatisticCardWithAreaChart.vue";
import StatisticCardWithLineChart from "@core/components/statistics-cards/StatisticCardWithLineChart.vue";
import { kFormatter } from "@core/utils/filter";

import CardStatisticOrderChart from "../../card/card-statistic/CardStatisticOrderChart.vue";
import CardStatisticProfitChart from "../../card/card-statistic/CardStatisticProfitChart.vue";
import CardStatisticsGroup from "../../card/card-statistic/CardStatisticsGroup.vue";

export default {
  components: {
    BRow,
    BCol,
    StatisticCardVertical,
    StatisticCardHorizontal,
    StatisticCardWithAreaChart,
    StatisticCardWithLineChart,
    CardStatisticOrderChart,
    CardStatisticProfitChart,
    CardStatisticsGroup,
  },
  props: ["data"],
  data() {
    return {
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      // Area charts
      subscribersGained: {},
      revenueGenerated: {},
      quarterlySales: {},
      ordersRecevied: {},

      // Line Charts
      siteTraffic: {},
      activeUsers: {},
      newsletter: {},
      first: [],
      second: [],
      third: [],
      visitCount: 0,
    };
  },
  mounted() {
    this.subscribersGained = {
      analyticsData: {
        subscribers: 92600,
      },
      series: [{ data: [28, 40, 36, 52, 38, 60, 55], name: "sales" }],
    };
    this.data.map((item, index) => {
      if (index < 4) {
        this.first.push(item);
      } else if (index < 8) {
        this.second.push(item);
      } else {
        this.third.push(item);
      }
    });
    this.pendingRequest();
  },
  //   created() {
  //     // Subscribers gained
  //     this.$http.get("/card/card-statistics/subscribers").then((response) => {
  //       this.subscribersGained = response.data;
  //       this.subscribersGained.series[0].name = "sales";
  //       console.log(this.subscribersGained, "first");
  //     });
  //   },

  methods: {
    kFormatter,
    handleClick(item) {
      if (item.route) {
        this.$router.push(item.route);
      }
    },
    handleClickvisit() {
      this.$router.push({ path: "/crm/sitevisit", query: { pending: true } });
    },
    async pendingRequest() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/pendingvisitCount`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.visitCount = response.data.data.length;
        })
        .catch((error) => console.log(error, "error"));
    },
    // async totalsales() {
    //   await axios({
    //     method: "GET",
    //     url: `${this.baseApi}/totalsale`,
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${this.accessToken}`,
    //     },
    //   }).then((response) => {});
    // },
  },
};
</script>
